import { generateClient } from 'aws-amplify/api'
import { convertTextToSpeech as convertTextToSpeechMutation } from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export function extractTextAudioUrl(response) {
  const payload = parseAwsJson(response) ?? response
  if (!payload || typeof payload !== 'object') return ''

  const data = payload.data ?? payload.Data ?? payload

  const url =
    data?.OutputUri ??
    data?.output_uri ??
    data?.text_audio_url ??
    data?.textAudioUrl ??
    payload.OutputUri ??
    payload.output_uri ??
    ''

  return String(url).trim()
}

export default {
  methods: {
    async convertTextToSpeech(input = {}) {
      try {
        const { data, errors } = await client.graphql({
          query: convertTextToSpeechMutation,
          variables: { input },
        })

        const parsed = parseAwsJson(data?.convertTextToSpeech)
        if (parsed != null) {
          return parsed
        }

        if (errors?.length) {
          throw new Error(errors[0].message)
        }

        return null
      } catch (error) {
        return {
          status: 'ERROR',
          message: getApiMessage(error, 'Failed to generate audio'),
        }
      }
    },
  },
}
